import React, { Component } from 'react'
import { Resource, GET_LIST, registerResource, unregisterResource } from 'react-admin'
import { connect } from 'react-redux'

import { GenericCreate, GenericEdit, GenericList, GenericShow } from '../Generic'
import dataProvider from '../../utils/dataProvider'

 class GenericResource extends Component {

  constructor(props) {
      super(props)
      this.state = {
          inputs: [],
          fields: [],
          title : "",
          singularName : "",
      }
  }

  componentWillMount() {
    const {
      context,
      name,
      options,
      icon,
      registerResource,
    } = this.props;

    if (context === 'registration') {
      const resource = {
        name,
        options,
        hasList: true,
        hasEdit: true,
        hasShow: true,
        hasCreate: true,
        icon,
      };
      registerResource(resource);
    }
  }

  componentDidMount() {
    if (this.props.context !== "registration"){
      const params = {
        pagination: {
          page: 1,
          perPage: 1
        },
        sort: {
          field: 'id',
          order: 'ASC'
        },
        filter: {
          slug: this.props.name
        }
      }
      dataProvider(GET_LIST, 'tipos-instalaciones', params)
        .then(result => {
          console.log(result);
          if (result.total === 1){
            const title = result.data[0].name
            const singularName = result.data[0].singular_name
            const { fields, inputs } = result.data[0].shape
            return {
              title,
              singularName,
              fields,
              inputs,
              schema: result.data[0].datasheet
            }
          } else {
            return {
              title : "",
              singularName : "",
              fields: [],
              inputs: [],
              schema: null
            }
          }
        })
        .then(shape => this.setState({ ...shape }))
    }
  }

  componentWillUnmount() {
    const { context, name, unregisterResource } = this.props;
    if (context === 'registration') {
      unregisterResource(name);
    }
  }

  render() {
    if (this.props.context === 'registration') {
      return null
    } else if (this.props.permissions === null) {
      return null
    }

    const { permissions: { role } } = this.props

    return (
      <Resource
        create={!!role && ["admin", "coordinador"].includes(role)
          ? (props) => (
              <GenericCreate
                  {...props}
                  title={this.state.singularName}
                  inputs={this.state.inputs}
                  schema={this.state.schema}/>
          )
          : null
        }
        edit={!!role && !(role === "externo" && this.props.name === "empresas") && role !== "guest"
          ? (props) => (
              <GenericEdit
                  {...props}
                  title={this.state.singularName}
                  inputs={this.state.inputs}
                  schema={this.state.schema}/>
          )
          : null
        }
        list={(props) => (
          <GenericList
            {...props}
            fields={this.state.fields}
            title={this.state.title}
          />
        )}
        show={(props) => (
          <GenericShow
            {...props}
            title={this.state.singularName}
            fields={this.state.fields}
            schema={this.state.schema}/>
        )}
        {...this.props}
      />
    )
  }
}


export default connect(
    null,
    { registerResource, unregisterResource }
)(GenericResource);
